import { sfxr } from 'jsfxr'
// sound data
import jumpJson from '../../sounds/jump.json'
import ripJson from '../../sounds/rip.json'
import landJson from '../../sounds/land.json'

// sound "loading/creation" using sfxr
const jump = sfxr.toAudio(jumpJson)
const rip = sfxr.toAudio(ripJson)
const land = sfxr.toAudio(landJson)

// sound pool
export const sounds = {
	rip: () => rip.play(),
	jump: () => jump.play(),
	land: () => land.play(),
}
